export class SqlQueryExecution {
    'id';
    'sqlEngineId';
    'sqlEngineName';
    'query';
    'status';
    'createdAt';
    'finishedAt';
    'errorMessage';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "sqlEngineId",
            "baseName": "sqlEngineId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "sqlEngineName",
            "baseName": "sqlEngineName",
            "type": "string",
            "format": ""
        },
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SqlQueryExecutionStatus",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "finishedAt",
            "baseName": "finishedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "errorMessage",
            "baseName": "errorMessage",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SqlQueryExecution.attributeTypeMap;
    }
    constructor() {
    }
}
